import axios from 'axios';
import { ENV_CONFIG } from '../../../config/config';


export const iniciarSolicitudApi = (tokenAutorizacion:any,bodyFormData:any) =>    
    axios.create({     
    baseURL: `${ENV_CONFIG.SERVICIO_MFTGAW_URL}`,
    headers: {
        'Authorization': 'Bearer ' + tokenAutorizacion,
        'Content-Type': 'multipart/form-data'
    },
}).post(``,bodyFormData)


export const ConfirmarSolicitudApi = (bodyFormData:any, tokenAutorizacion:any) =>    
    axios.create({     
    baseURL: `${ENV_CONFIG.CONFIRMAR_MFTGAW_URL}`,

    headers: {
        'Authorization': 'Bearer ' + tokenAutorizacion,
        'Content-Type': 'application/json'
    },
   
}).post(``,bodyFormData)


export const ConsultarAseguramientoApi = (bodyFormData:any, tokenAutorizacion:any) =>    
    axios.create({     
    baseURL: `${ENV_CONFIG.ASEGURAMIENTO_MFTGAW_URL}`,

    headers: {
        'Authorization': 'Bearer ' + tokenAutorizacion,
        'Content-Type': 'application/json'
    },
   
}).post(``,bodyFormData)

